import { useEnglishText } from "../../text/useEnglishText.js";
import "../../styles/Tabs.css";

export default function DocumentsTabs({ active, onChange, tabs }) {
  const { t } = useEnglishText();

  return (
    <div className="documents-tabs" role="tablist">
      {tabs.map((item) => {
        const tab = typeof item === "string" ? item : item.value;
        const label = typeof item === "string" ? t(`documents.tabs.${tab}`) : item.label;
        return (
          <button
            key={tab}
            type="button"
            role="tab"
            aria-selected={active === tab}
            className={active === tab ? "active" : ""}
            onClick={() => onChange(tab)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
